@if (isAdminImpersonatingUser()) {
  <div id="logged-as-banner">
    <h1>{{ 'admin_login-as_you-are-connected' | translate }} {{ userEmail() }}</h1>
    <span (click)="disconnect()"> {{ 'logout' | translate }}</span>
  </div>
}
